export const enviroment = {
    apiUrl: process.env["REACT_APP_API"]!,
    authUrl: process.env["REACT_APP_AUTH"]!,
    authHub: process.env["REACT_APP_HUB_ADDRESS"]!
};
